<div class="modal-header">
	<h4 class="modal-title" id="modal-title" *ngIf="key">{{key}}</h4>
	<h4 class="modal-title" id="modal-title" *ngIf="!key">Value</h4>
	<button type="button" class="close" (click)="modal.close()">
        <span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body relay-word-wrap" id="modal-body">
    {{value}}
</div>
